/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import clsx from 'clsx'

type Props = {
  label: string
  placeholder?: string
  value?: string
  touched?: any
  errors?: any
  props?: any
}

const DateTimePickerWithLabel: React.FC<Props> = ({
  label,
  placeholder,
  value,
  touched,
  errors,
  props,
}) => {
  return (
    <div className='fv-row mb-8'>
      <label className='form-label fw-bolder text-dark fs-6'>{label}</label>
      <input
        placeholder={placeholder}
        type='date'
        locale='tr-TR'
        autoComplete='off'
        {...props}
        className={clsx(
          'form-control bg-transparent',
          {
            'is-invalid': touched && errors,
          },
          {
            'is-valid': touched && !errors,
          }
        )}
        defaultValue={value}
      />
      {touched && errors && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{errors}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export {DateTimePickerWithLabel}
